import { useEffect } from "react";
import { Toaster, toast } from "react-hot-toast";
import { getFirebaseToken, onMessageListener } from "../../FirebaseConfig";
import { getOrCreateDeviceToken, setDeviceToken } from "../../utils/deviceToken";
import { playNewOrderAlert } from "../../utils/newOrderAlert";

function Notification() {
  useEffect(() => {
    getOrCreateDeviceToken();

    if (!("Notification" in window)) return;

    let cancelled = false;

    window.Notification.requestPermission()
      .then(async (permission) => {
        if (cancelled || permission !== "granted") return;

        try {
          const firebaseToken = await getFirebaseToken();
          if (!cancelled && firebaseToken) {
            setDeviceToken(firebaseToken);
          }
        } catch (error) {
          console.warn("Firebase token setup skipped:", error);
        }

        try {
          const payload: any = await onMessageListener();
          if (cancelled || !payload?.notification) return;

          playNewOrderAlert();

          toast.success(
            `${payload.notification.title}, ${payload.notification.body}`,
            {
              duration: 60000,
              style: {
                border: "1px solid #1EC677",
                padding: "10px 25px",
                color: "#1EC677",
              },
              iconTheme: {
                primary: "#1EC677",
                secondary: "#00190D",
              },
            }
          );
        } catch (error) {
          console.warn("Firebase message listener skipped:", error);
        }
      })
      .catch((error) => {
        console.warn("Notification permission request skipped:", error);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div>
      <Toaster />
    </div>
  );
}

export default Notification;
